import React from 'react';
import PropTypes from 'prop-types';
import ReactInputMask from 'react-input-mask';
import UiComponent from '../UiComponent';

export default class InputMask extends UiComponent {

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(value) {
    this.props.field.value = value;
    if (this.props.relatedTo && this.props.relatedTo.length > 0) {
      this.props.onChange([
          this.props.relatedTo,
          this.props.field.name,
        ],
        this.props.field
      );
    } else {
      this.props.onChange(this.props.field.name, this.props.field);
    }
  }

  render() {
    const containerClass = `form-group ${this.props.className}`;
    let disabled = false;
    if (this.getFieldProp('system') && this.getFieldProp('system').disabled) {
      disabled = true;
    }
    return (
      <div className={containerClass}>
        {this.getLabel()}
        <ReactInputMask
          autoComplete="off"
          type={this.getFieldProp('type')}
          className="form-control"
          placeholder={this.getFieldProp('placeholder')}
          onChange={e => this.changeValue(e.target.value)}
          value={this.getFieldProp('value')}
          disabled={disabled || this.props.disabled}
          mask={this.getFieldProp('mask')}
          maskChar={this.getFieldProp('maskChar')}
        />
        {this.getErrors()}
      </div>
    );
  }
}

InputMask.propTypes = {
  relatedTo: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.object,
  field: PropTypes.object,
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/common/InputMask/index.js